/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../common/location';
import './common';
import '../common/currency_codes';
import '../merchants/api';
import '../common/gateways';
import '../common/merchant_type';
import '../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "roster": {
        "nested": {
          "service": {
            "nested": {
              "Subscription": {
                "fields": {
                  "productKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.roster.service.Subscription.Status",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "PENDING": 0,
                      "FREE_TRIAL": 1,
                      "ACTIVE": 2,
                      "CANCELED": 3,
                      "IN_GRACE": 4,
                      "DELINQUENT": 5,
                      "TERMINATED": 6
                    }
                  }
                }
              },
              "HourData": {
                "fields": {
                  "open": {
                    "type": ".squareup.common.time.LocalTime",
                    "id": 1,
                    "rule": "optional"
                  },
                  "durationMinutes": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Hour": {
                "fields": {
                  "dayOfWeek": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "data": {
                    "type": ".squareup.roster.service.HourData",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "MerchantImage": {
                "fields": {
                  "url": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "centerX": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "centerY": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "originalHeight": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "originalWidth": {
                    "type": "int32",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "MerchantProfileLookupResponse": {
                "fields": {
                  "status": {
                    "type": ".squareup.roster.service.UserLookupStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "secondaryName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tertiaryName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "slug": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "cardColor": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "facebookUrl": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "websiteUrl": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "twitter": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "curatedImageUrl": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "mobileMerchant": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional"
                  },
                  "published": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.location.Address",
                    "id": 14,
                    "rule": "optional"
                  },
                  "merchantImageUrls": {
                    "type": "string",
                    "id": 15,
                    "rule": "repeated"
                  },
                  "returnPolicy": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "canadianMerchantProfile": {
                    "type": ".squareup.roster.service.MerchantProfileLookupResponse.CanadianMerchantProfile",
                    "id": 17,
                    "rule": "optional"
                  },
                  "userToken": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "globalAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 19,
                    "rule": "optional"
                  },
                  "logoImage": {
                    "type": ".squareup.roster.service.MerchantImage",
                    "id": 20,
                    "rule": "optional"
                  },
                  "profileToken": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 22,
                    "rule": "optional"
                  },
                  "businessType": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "profileImages": {
                    "type": ".squareup.roster.service.MerchantImage",
                    "id": 24,
                    "rule": "repeated"
                  },
                  "location": {
                    "type": ".squareup.common.location.GeoLocation",
                    "id": 25,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": ".squareup.common.location.Phone",
                    "id": 26,
                    "rule": "optional"
                  },
                  "tzName": {
                    "type": "string",
                    "id": 27,
                    "rule": "optional"
                  },
                  "shortSquareUrl": {
                    "type": "string",
                    "id": 28,
                    "rule": "optional"
                  },
                  "squareUrl": {
                    "type": "string",
                    "id": 29,
                    "rule": "optional"
                  },
                  "normalHours": {
                    "type": ".squareup.roster.service.Hour",
                    "id": 30,
                    "rule": "repeated"
                  },
                  "shippingEnabled": {
                    "type": "bool",
                    "id": 31,
                    "rule": "optional"
                  },
                  "pickupEnabled": {
                    "type": "bool",
                    "id": 32,
                    "rule": "optional"
                  },
                  "tippingPreference": {
                    "type": ".squareup.roster.common.TippingPreference",
                    "id": 33,
                    "rule": "optional"
                  },
                  "permissions": {
                    "type": "string",
                    "id": 34,
                    "rule": "repeated"
                  },
                  "legacyUserId": {
                    "type": "string",
                    "id": 35,
                    "rule": "optional"
                  },
                  "receiptShowItemDescription": {
                    "type": "bool",
                    "id": 36,
                    "rule": "optional"
                  },
                  "receiptShowLocation": {
                    "type": "bool",
                    "id": 37,
                    "rule": "optional"
                  },
                  "organizationMemberships": {
                    "type": ".squareup.roster.service.MerchantProfileLookupResponse.OrganizationMembership",
                    "id": 38,
                    "rule": "repeated"
                  },
                  "multiunitParentToken": {
                    "type": "string",
                    "id": 39,
                    "rule": "optional"
                  },
                  "currencyCode": {
                    "type": ".squareup.common.CurrencyCode",
                    "id": 40,
                    "rule": "optional"
                  },
                  "receiptShowReferral": {
                    "type": "bool",
                    "id": 41,
                    "rule": "optional"
                  },
                  "tzSource": {
                    "type": ".squareup.roster.service.TzSource",
                    "id": 42,
                    "rule": "optional"
                  },
                  "printedReceiptLogoImageUrl": {
                    "type": "string",
                    "id": 43,
                    "rule": "optional"
                  },
                  "customReceiptText": {
                    "type": "string",
                    "id": 44,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CanadianMerchantProfile": {
                    "fields": {
                      "gstHstNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "qstNumber": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "OrganizationMembership": {
                    "fields": {
                      "organizationName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "organizationId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "PayerLookupResponse": {
                "fields": {
                  "emailId": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "obfuscatedEmail": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "phoneId": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "obfuscatedPhone": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "hasActivePaymentSource": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "automaticReceiptOptOut": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "permissions": {
                    "type": "string",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "payerToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "profileImageUrl": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "PrivateInformation": {
                "fields": {
                  "type": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tinFideliusToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UnderwritingDecision": {
                "fields": {
                  "state": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "TzSource": {
                "values": {
                  "FIXED": 0,
                  "MERCHANT": 1
                }
              },
              "UserLookupStatus": {
                "values": {
                  "INVALID": 0,
                  "SUCCESS": 1,
                  "FAILURE": 2,
                  "ERROR": 3
                }
              },
              "UserLookupResponse": {
                "fields": {
                  "status": {
                    "type": ".squareup.roster.service.UserLookupStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "message": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "legacyUserId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "userToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "secondaryName": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "tertiaryName": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.location.Address",
                    "id": 9,
                    "rule": "optional"
                  },
                  "userLocale": {
                    "type": ".squareup.merchants.api.UserLocale",
                    "id": 10,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": ".squareup.common.location.Phone",
                    "id": 11,
                    "rule": "optional"
                  },
                  "categoryCode": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "permissions": {
                    "type": "string",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "userTokensCanTakePaymentsTo": {
                    "type": "string",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "transactionFund": {
                    "type": ".squareup.merchants.api.TransactionFund",
                    "id": 15,
                    "rule": "optional"
                  },
                  "gatewayMerchantTokens": {
                    "type": ".squareup.roster.service.UserLookupResponse.GatewayMerchantToken",
                    "id": 16,
                    "rule": "repeated"
                  },
                  "fees": {
                    "type": ".squareup.merchants.api.UserFees",
                    "id": 17,
                    "rule": "optional"
                  },
                  "supportsTabs": {
                    "type": "bool",
                    "id": 18,
                    "rule": "optional"
                  },
                  "businessType": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "tippingPreference": {
                    "type": ".squareup.roster.common.TippingPreference",
                    "id": 20,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "delegateCustomId": {
                    "type": "string",
                    "id": 22,
                    "rule": "optional"
                  },
                  "profileImageUrl": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "gatewayHints": {
                    "type": ".squareup.common.gateways.GatewayName",
                    "id": 24,
                    "rule": "repeated"
                  },
                  "shippingPhone": {
                    "type": ".squareup.common.location.Phone",
                    "id": 25,
                    "rule": "optional"
                  },
                  "businessName": {
                    "type": "string",
                    "id": 26,
                    "rule": "optional"
                  },
                  "secondaryBusinessName": {
                    "type": "string",
                    "id": 27,
                    "rule": "optional"
                  },
                  "tertiaryBusinessName": {
                    "type": "string",
                    "id": 28,
                    "rule": "optional"
                  },
                  "userName": {
                    "type": "string",
                    "id": 29,
                    "rule": "optional"
                  },
                  "currencyCode": {
                    "type": ".squareup.common.CurrencyCode",
                    "id": 30,
                    "rule": "optional"
                  },
                  "merchantType": {
                    "type": ".squareup.common.MerchantType",
                    "id": 31,
                    "rule": "optional"
                  },
                  "tzName": {
                    "type": "string",
                    "id": 32,
                    "rule": "optional"
                  },
                  "shippingEnabled": {
                    "type": "bool",
                    "id": 33,
                    "rule": "optional"
                  },
                  "pickupEnabled": {
                    "type": "bool",
                    "id": 34,
                    "rule": "optional"
                  },
                  "businessSubtype": {
                    "type": "string",
                    "id": 35,
                    "rule": "optional"
                  },
                  "frozen": {
                    "type": "bool",
                    "id": 36,
                    "rule": "optional"
                  },
                  "subscription": {
                    "type": ".squareup.roster.service.Subscription",
                    "id": 37,
                    "rule": "repeated"
                  },
                  "subscriptionFeatureStatus": {
                    "type": ".squareup.roster.common.SubscriptionFeatureStatus",
                    "id": 49,
                    "rule": "repeated"
                  },
                  "shippingAddress": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 38,
                    "rule": "optional"
                  },
                  "isMultiunit": {
                    "type": "bool",
                    "id": 39,
                    "rule": "optional"
                  },
                  "businessCategory": {
                    "type": "string",
                    "id": 40,
                    "rule": "optional"
                  },
                  "businessSubCategory": {
                    "type": "string",
                    "id": 41,
                    "rule": "optional"
                  },
                  "personalFirstName": {
                    "type": "string",
                    "id": 42,
                    "rule": "optional"
                  },
                  "personalLastName": {
                    "type": "string",
                    "id": 43,
                    "rule": "optional"
                  },
                  "parentMerchantToken": {
                    "type": "string",
                    "id": 44,
                    "rule": "optional"
                  },
                  "privateInformation": {
                    "type": ".squareup.roster.service.PrivateInformation",
                    "id": 45,
                    "rule": "repeated"
                  },
                  "underwritingDecision": {
                    "type": ".squareup.roster.service.UnderwritingDecision",
                    "id": 46,
                    "rule": "optional"
                  },
                  "canadianMerchantProfile": {
                    "type": ".squareup.roster.service.MerchantProfileLookupResponse.CanadianMerchantProfile",
                    "id": 47
                  },
                  "ukMerchantProfile": {
                    "type": ".squareup.roster.service.UserLookupResponse.UkMerchantProfile",
                    "id": 48
                  },
                  "frMerchantProfile": {
                    "type": ".squareup.roster.service.UserLookupResponse.FrMerchantProfile",
                    "id": 50
                  }
                },
                "nested": {
                  "GatewayMerchantToken": {
                    "fields": {
                      "gateway": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "merchantToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "disabledTimestamp": {
                        "type": "int64",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "UkMerchantProfile": {
                    "fields": {
                      "vatNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "vatCustomerClass": {
                        "type": ".squareup.roster.service.UserLookupResponse.UkMerchantProfile.VatCustomerClass",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "VatCustomerClass": {
                        "values": {
                          "b2b_null": 1,
                          "b2b": 2
                        }
                      }
                    }
                  },
                  "FrMerchantProfile": {
                    "fields": {
                      "siren": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "tva": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "nic": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "country_specific_merchant_profile": {
                    "oneof": ["canadianMerchantProfile", "ukMerchantProfile", "frMerchantProfile"]
                  }
                }
              },
              "EmployeeLookupResponse": {
                "fields": {
                  "status": {
                    "type": ".squareup.roster.service.UserLookupStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "firstName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "lastName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "employeeNumber": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "active": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "merchantSuppliedEmail": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": ".squareup.common.location.Phone",
                    "id": 10,
                    "rule": "optional"
                  },
                  "credentialEmail": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "hasPasscode": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional"
                  },
                  "canAccessPayroll": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "isAccountOwner": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional"
                  },
                  "isOwner": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional"
                  },
                  "hourlyWageRate": {
                    "type": ".squareup.common.Money",
                    "id": 16,
                    "rule": "optional"
                  },
                  "annualWageRate": {
                    "type": ".squareup.common.Money",
                    "id": 17,
                    "rule": "optional"
                  },
                  "wageType": {
                    "type": ".squareup.roster.service.EmployeeLookupResponse.WageType",
                    "id": 18,
                    "rule": "optional"
                  },
                  "hoursWorkedPerWeek": {
                    "type": "uint32",
                    "id": 19,
                    "rule": "optional"
                  },
                  "flsaExempt": {
                    "type": "bool",
                    "id": 20,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "WageType": {
                    "values": {
                      "HOURLY": 0,
                      "ANNUAL": 1
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.Subscription && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.Subscription?.nested?.Status && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.HourData && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.Hour && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.MerchantImage && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.MerchantProfileLookupResponse && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.MerchantProfileLookupResponse?.nested?.CanadianMerchantProfile && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.MerchantProfileLookupResponse?.nested?.OrganizationMembership && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.PayerLookupResponse && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.PrivateInformation && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.UnderwritingDecision && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.TzSource && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.UserLookupStatus && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.UserLookupResponse && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.UserLookupResponse?.nested?.GatewayMerchantToken && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.UserLookupResponse?.nested?.UkMerchantProfile && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.UserLookupResponse?.nested?.UkMerchantProfile?.nested?.VatCustomerClass && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.UserLookupResponse?.nested?.FrMerchantProfile && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.EmployeeLookupResponse && !$root.nested?.squareup?.nested?.roster?.nested?.service?.nested?.EmployeeLookupResponse?.nested?.WageType) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT!
 * DO NOT USE squareup.validation on responses! It's non-trivially expensive, and on batch endpoints
 * can cause large amounts of work to be done on large responses. Since we're moving towards
 * batching for all endpoints, we should not be using validation at all on responses.
 * This proto will be deprecated soon in favor of SubscriptionFeatureStatus.
 *
 * SOURCE Subscription @ squareup/roster/service.proto at 30:1
 */
export const Subscription = $root.lookupType('squareup.roster.service.Subscription');
fixType(Subscription);
Builder.createAndAttachToType(Subscription);
/**
 * SOURCE Status @ squareup/roster/service.proto at 31:3
 */
Subscription.Status = $root.lookupEnum('squareup.roster.service.Subscription.Status').values;
/**
 * SOURCE HourData @ squareup/roster/service.proto at 106:1
 */
export const HourData = $root.lookupType('squareup.roster.service.HourData');
fixType(HourData);
Builder.createAndAttachToType(HourData);
/**
 * SOURCE Hour @ squareup/roster/service.proto at 114:1
 */
export const Hour = $root.lookupType('squareup.roster.service.Hour');
fixType(Hour);
Builder.createAndAttachToType(Hour);
/**
 * SOURCE MerchantImage @ squareup/roster/service.proto at 126:1
 */
export const MerchantImage = $root.lookupType('squareup.roster.service.MerchantImage');
fixType(MerchantImage);
Builder.createAndAttachToType(MerchantImage);
/**
 * SOURCE MerchantProfileLookupResponse @ squareup/roster/service.proto at 147:1
 */
export const MerchantProfileLookupResponse = $root.lookupType('squareup.roster.service.MerchantProfileLookupResponse');
fixType(MerchantProfileLookupResponse);
Builder.createAndAttachToType(MerchantProfileLookupResponse);
/**
 * SOURCE CanadianMerchantProfile @ squareup/roster/service.proto at 148:3
 */
MerchantProfileLookupResponse.CanadianMerchantProfile = $root.lookupType('squareup.roster.service.MerchantProfileLookupResponse.CanadianMerchantProfile');
fixType(MerchantProfileLookupResponse.CanadianMerchantProfile);
Builder.createAndAttachToType(MerchantProfileLookupResponse.CanadianMerchantProfile);
/**
 * SOURCE OrganizationMembership @ squareup/roster/service.proto at 156:3
 */
MerchantProfileLookupResponse.OrganizationMembership = $root.lookupType('squareup.roster.service.MerchantProfileLookupResponse.OrganizationMembership');
fixType(MerchantProfileLookupResponse.OrganizationMembership);
Builder.createAndAttachToType(MerchantProfileLookupResponse.OrganizationMembership);
/**
 * SOURCE PayerLookupResponse @ squareup/roster/service.proto at 336:1
 */
export const PayerLookupResponse = $root.lookupType('squareup.roster.service.PayerLookupResponse');
fixType(PayerLookupResponse);
Builder.createAndAttachToType(PayerLookupResponse);
/**
 * SOURCE PrivateInformation @ squareup/roster/service.proto at 404:1
 */
export const PrivateInformation = $root.lookupType('squareup.roster.service.PrivateInformation');
fixType(PrivateInformation);
Builder.createAndAttachToType(PrivateInformation);
/**
 * SOURCE UnderwritingDecision @ squareup/roster/service.proto at 418:1
 */
export const UnderwritingDecision = $root.lookupType('squareup.roster.service.UnderwritingDecision');
fixType(UnderwritingDecision);
Builder.createAndAttachToType(UnderwritingDecision);
/**
 * How the time zone was determined.
 *
 * In the future, this will support more options, such as ADDRESS (i.e. we automatically determined a timezone from an address).
 *
 * SOURCE TzSource @ squareup/roster/service.proto at 428:1
 */
export const TzSource = $root.lookupEnum('squareup.roster.service.TzSource').values;
/**
 * SOURCE UserLookupStatus @ squareup/roster/service.proto at 534:1
 */
export const UserLookupStatus = $root.lookupEnum('squareup.roster.service.UserLookupStatus').values;
/**
 * SOURCE UserLookupResponse @ squareup/roster/service.proto at 545:1
 */
export const UserLookupResponse = $root.lookupType('squareup.roster.service.UserLookupResponse');
fixType(UserLookupResponse);
Builder.createAndAttachToType(UserLookupResponse);
/**
 * SOURCE GatewayMerchantToken @ squareup/roster/service.proto at 546:3
 */
UserLookupResponse.GatewayMerchantToken = $root.lookupType('squareup.roster.service.UserLookupResponse.GatewayMerchantToken');
fixType(UserLookupResponse.GatewayMerchantToken);
Builder.createAndAttachToType(UserLookupResponse.GatewayMerchantToken);
/**
 * SOURCE UkMerchantProfile @ squareup/roster/service.proto at 685:3
 */
UserLookupResponse.UkMerchantProfile = $root.lookupType('squareup.roster.service.UserLookupResponse.UkMerchantProfile');
fixType(UserLookupResponse.UkMerchantProfile);
Builder.createAndAttachToType(UserLookupResponse.UkMerchantProfile);
/**
 * SOURCE VatCustomerClass @ squareup/roster/service.proto at 689:5
 */
UserLookupResponse.UkMerchantProfile.VatCustomerClass = $root.lookupEnum('squareup.roster.service.UserLookupResponse.UkMerchantProfile.VatCustomerClass').values;
/**
 * SOURCE FrMerchantProfile @ squareup/roster/service.proto at 697:3
 */
UserLookupResponse.FrMerchantProfile = $root.lookupType('squareup.roster.service.UserLookupResponse.FrMerchantProfile');
fixType(UserLookupResponse.FrMerchantProfile);
Builder.createAndAttachToType(UserLookupResponse.FrMerchantProfile);
/**
 * A set of employees matching EmployeeLookupRequest or EmployeeBatchLookupRequest.
 *
 * SOURCE EmployeeLookupResponse @ squareup/roster/service.proto at 844:1
 */
export const EmployeeLookupResponse = $root.lookupType('squareup.roster.service.EmployeeLookupResponse');
fixType(EmployeeLookupResponse);
Builder.createAndAttachToType(EmployeeLookupResponse);
/**
 * Employee's wage type. WageType.HOURLY if paid hourly, ANNUAL if salaried annually
 *
 * SOURCE WageType @ squareup/roster/service.proto at 897:3
 */
EmployeeLookupResponse.WageType = $root.lookupEnum('squareup.roster.service.EmployeeLookupResponse.WageType').values;